import { fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, spacing, text } = theme;

const font = css`
  ${fontSize(text.BODY.MD)};
  color: var(--neutral-black-base);
`;

const gridLabel = css`
  grid-column: 1 / 3;
`;

const gridPrice = css`
  grid-column: 4 / -1;
`;

export const priceBreakdown = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: ${pxToRem(spacing.xs)};
  margin-bottom: ${spacing.sm}px;
`;

export const priceLabel = css`
  ${font};
  ${gridLabel};
  margin: 0;
`;

export const priceAmount = css`
  ${font};
  ${gridPrice};
  margin: 0;
  display: flex;
  align-items: center;
`;

export const personalisationBreakdown = css`
  grid-column: span 12;
  row-gap: ${pxToRem(spacing.xs)};
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-left: ${spacing.md}px;
`;

export const personalisationBreakdownCopy = css`
  margin: 0 0 0 ${-spacing.md}px;
`;

export const priceAmountMinusSymbol = css`
  margin-left: 0;
  margin-right: ${pxToRem(2)};
  ${fontSize(text.BODY.SM)};

  &[data-is-multi-digit='true'] {
    margin-left: ${-spacing.sm}px;
  }
`;

export const priceAmountPlusSymbol = css`
  ${/* Double ampersand selector to increase specificity and override existing styles */ ''}
  && {
    ${fontSize(text.HEADING.SM)};
  }
`;

export const totalLabel = css`
  ${priceLabel};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;

export const totalPrice = css`
  ${priceAmount};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;
